<template>
  <div class="page">
    <div class="page__hd">
      <div class="page__hd--title">{{ store }}</div>
    </div>
    <div class="page__bd">
      <div class="panel">
        <div class="panel__bd" @click="KeyboardShow = true">
          <div class="panel__bd--hd">消费金额</div>
          <div class="panel__bd--bd">
            <div class="panel__bd--bd--text">¥{{ text }}</div>
          </div>
        </div>
        <div class="panel__ft" @click="popup = true">
          <div class="panel__ft--bd">
            <div v-if="remark" class="panel__ft--bd--text">{{ remark }}</div>
            <div v-else class="panel__ft--bd--hint">添加付款备注，最多50个字</div>
          </div>
          <div class="panel__ft--ft">添加备注<van-icon name="edit" /></div>
        </div>
      </div>
    </div>
    <van-number-keyboard
      theme="custom"
      extra-key="."
      close-button-text="立即支付"
      :show="KeyboardShow"
      :hide-on-click-outside="false"
      @blur="onPay"
      @input="handleInput"
      @delete="handleDelete"
    />
    <van-popup v-model="popup" closeable :style="{ width: '88vw' }">
      <div class="popup__container">
        <van-field
          v-model="remark2"
          rows="2"
          type="textarea"
          maxlength="50"
          placeholder="请输入付款备注"
          show-word-limit
        />
        <div class="popup__container--btn">
          <van-button @click="onSubmitRemark" round block type="primary">保存</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Toast } from 'vant'
let tt
export default {
  data () {
    return {
      loading: false,
      KeyboardShow: true,
      nums: [],
      text: '',
      store: '',
      remark: '',
      remark2: '',
      popup: false
    }
  },
  computed: {
    uid () {
      return this.$route.query.id || ''
    }
  },
  async created () {
    if (this.uid) {
      Toast.loading({
        duration: 0,
        forbidClick: true
      })
      await this.$axios.post('receipt/store', {
        uid: this.uid
      }).then(response => {
        console.log(response)
        if (response.data.code === 200) {
          const res = response.data.data || {}
          this.store = res.name
        }
      }).catch((e) => {
        console.log(e)
      })
      Toast.clear()
    }
  },
  destroyed () {
    tt && clearTimeout(tt)
  },
  methods: {
    handleDelete () {
      this.nums.pop()
      this.text = this.nums.join('')
    },
    onSubmitRemark () {
      this.remark = this.remark2
      this.popup = false
    },
    onPay () {
      const num = Number(this.text)
      if (Number.isNaN(num) || num <= 0) {
        Toast('请输入正确的金额')
        return false
      }

      if (!this.store) {
        Toast('支付页面错误，请刷新重试')
        return
      }
      if (this.loading) {
        return
      }
      console.log(num)
      Toast.loading({
        duration: 0,
        forbidClick: true
      })
      this.loading = true
      tt && clearTimeout(tt)
      tt = setTimeout(async () => {
        console.log('sss')
        await this.$axios.post('receipt/createPay', {
          uid: this.uid,
          money: num,
          remark: this.remark
        }).then(response => {
          Toast.clear()
          this.loading = false
          if (response.data.code === 200) {
            console.log(response.data)
            const res = response.data.data || {}
            window.location.href = res.url
          } else {
            Toast(response.data.message || '发起支付失败')
          }
        }).catch(e => {
          console.log(e)
          this.loading = false
          Toast('网络不给力')
        })
      }, 200)
    },
    handleInput (value) {
      console.log(value)
      if (this.nums.length === 0 && value === '.') {
        return
      }

      if (this.nums.includes('.') && value === '.') {
        return
      }
      if (this.nums.includes('.')) {
        const idx = this.nums.indexOf('.')
        const len = this.nums.length - 1
        if (len - idx >= 2) {
          return
        }
      }
      this.nums.push(value)
      this.text = this.nums.join('')
    }
  }
}
</script>
<style lang="less" scoped>
  .page {
    min-height: 100vh;
    background: #f5f5f5;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .page__hd {
    background: #00c441;
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: center;
    &--title {
      padding: 0 16px;
      font-size: 18px;
      color: #fff;
      font-weight: 500;
      text-align: center;
      line-height: 1.5;
    }
  }

  .page__bd {
    flex: 1;
  }

  .panel {
    background: #fff;
    padding: 12px 16px 0;
    &__bd {
      display: flex;
      align-items: center;
      border: 1px solid #00c441;
      padding: 0 16px;
      min-height: 88px;
      border-radius: 5px;
      overflow: hidden;
      &--hd {
        font-size: 18px;
        color: #3c3c3c;
        font-weight: normal;
      }
      &--bd {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        &--text {
          font-size: 24px;
          color: #000;
        }
      }
    }
    &__ft {
      display: flex;
      padding: 16px 0;
      &--bd {
        flex: 1;
        overflow: hidden;
        padding-right: 10px;
        &--hint {
          font-size: 12px;
          color: #999;
        }
        &--text {
          font-size: 12px;
          color: #3c3c3c;
          word-break: break-all;
        }
      }
      &--ft {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #00c441;
      }
    }
  }
  .popup__container {
    padding: 24px 0 0;
    &--btn {
      padding: 24px 16px;
    }
  }
</style>
